"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var formatSize = function (size) {
    if (typeof size === 'number')
        return size;
    return parseInt(size.replace('px', ''));
};
var useIconProps = function (iconProps) {
    return (0, react_1.useMemo)(function () {
        var width = iconProps.width, height = iconProps.height, _a = iconProps.size, size = _a === void 0 ? 32 : _a, style = iconProps.style, className = iconProps.className, onClick = iconProps.onClick, color = iconProps.color;
        return {
            width: width ? formatSize(width) : size,
            height: height ? formatSize(height) : size,
            style: __assign(__assign({}, style), { color: color }),
            className: className,
            onClick: onClick,
        };
    }, [iconProps]);
};
exports.default = useIconProps;
//# sourceMappingURL=use-icon-props.js.map